import ParkingCard from '@components/ParkingCard/ParkingCard.component'
import { useAuth } from '@context/AuthContext/AuthContext'
import { DateTime } from 'luxon'
import { SvLotType } from 'parkdepot-shared/gql/graphql'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { SpecificCarpayCard } from '../CarpayOrderCard.component'
import { CardExtraInfo } from '../CarpayOrderCard.style'
import CarpayOrderCardContent from '../CarpayOrderCardContent.component'
import CarpayOrderCardHeader from '../CarpayOrderCardHeader.component'
import FullyWhitelistedOrderCard from './FullyWhitelistedOrderCard.component'

const IncompleteCarpayOrderCard = ({
    order,
    discount,
    priceToBePaid,
    isLast,
    disabled,
    onClick,
    currency,
    fullyWhitelisted,
    lot
}: SpecificCarpayCard) => {
    const { isLoggedIn } = useAuth()
    const { t } = useTranslation()
    const startDate = DateTime.fromISO(order.start_date)
    const elapsetTimeFromEntrance = DateTime.now().diff(startDate).shiftTo('hours', 'minutes').toFormat("h'h' m'm'")
    const isTollRoad = SvLotType.TollRoad === lot.sv_lot_type

    const fullyWhitelistedCardProps = {
        order,
        lot,
        discount,
        priceToBePaid,
        fullyWhitelisted,
        currency,
        isLast,
        disabled,
        onClick
    }

    if (fullyWhitelisted) {
        return <FullyWhitelistedOrderCard {...fullyWhitelistedCardProps} />
    }

    let subtitle = null
    if (isLoggedIn && !isTollRoad) subtitle = `${t('carpay.orderCard.duration')}: ${elapsetTimeFromEntrance}`

    return (
        <ParkingCard isLast={isLast} disabled={disabled} onClick={onClick}>
            <CarpayOrderCardHeader
                text={startDate.toFormat('dd.MM.yyyy')}
                badgeText={t('carpay.orderStatuses.active')}
                badgeVariant="positive"
            />

            <CarpayOrderCardContent
                title={t('carpay.orderCard.currentPrice')}
                subtitle={subtitle}
                price={priceToBePaid}
                discount={discount}
                currency={currency}
            />

            {!isLoggedIn && <CardExtraInfo>{t('carpay.orderCard.privacyInfo')}</CardExtraInfo>}
        </ParkingCard>
    )
}

export default IncompleteCarpayOrderCard
